module.exports = __webpack_public_path__ + "media/images/lb/239-c3fe75a724de845cb49d508c2d3bef19.svg";